import { defineMessages } from 'react-intl'

export default defineMessages({
  unexpectedTitle: {
    id: 'app.error.unexpected.title',
    defaultMessage: 'An unexpected error occurred',
  },
  unexpectedBody: {
    id: 'app.error.unexpected.body',
    defaultMessage: 'Please go back or click the button below to return to the previous page',
  },
  unexpectedSupport: {
    id: 'app.error.unexpected.support',
    defaultMessage: 'If the problem persists please contact support@flixpremiere.com',
  },
})
